// extracted by mini-css-extract-plugin
export default {"wrapper":"AddTranche_wrapper__qKTVw","form":"AddTranche_form__wRiD2"};